export const weekdayOptions = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const weekdayToLuxonWeekday = [7, 1, 2, 3, 4, 5, 6];
export const luxonWeekdayToWeekday = [-1, 1, 2, 3, 4, 5, 6, 0];
